import api from './axios';

export const getBrandingBySlug = (slug) => api.get(`/empresas-operadoras/branding/${slug}`);
export const getBrandingAtiva = () => api.get('/empresas-operadoras/branding-ativa');

export const listEmpresas = () => api.get('/empresas-operadoras/');
export const getEmpresa = (id) => api.get(`/empresas-operadoras/${id}`);
export const createEmpresa = (data) => api.post('/empresas-operadoras/', data);
export const updateEmpresa = (id, data) => api.patch(`/empresas-operadoras/${id}`, data);

export const uploadLogo = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/empresas-operadoras/${id}/logo`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const uploadFavicon = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/empresas-operadoras/${id}/favicon`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
